import { render, staticRenderFns } from "./configuration-valuable-concepts-modal-basic-form.vue?vue&type=template&id=83e532cc&scoped=true&"
import script from "./configuration-valuable-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-valuable-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-valuable-concepts-modal-basic-form.scss?vue&type=style&index=0&id=83e532cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e532cc",
  null
  
)

export default component.exports